import api from "../../axiosConfig";


export const addmedicine = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/medicine/add-medicine', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getmedicine = async (search_keyword,doctor_id) => {
      console.log('search keyword:', search_keyword);
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/medicine/all-medicine', {
      
      params: {
        doctor_id: doctor_id,
          search_keyword: search_keyword // 

        }
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const updatemedicine = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`medicine/update-medicine/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
export const deletemedicine = async (id) => {
  try {
    const response = await api.delete(`medicine/delete/${id}`);

    const resData = response?.data;
    console.log('Delete medicine response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting medicine');
  }
};